/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const DefectiveHeader = ({ returnedItems }) => {
    const { RL_DEFECTIVE } = useSelector((state) => state);
    const REASON_CODES_NPOS = ['R9', 'R10', 'R11', 'R12', 'R13', 'R14', 'R15', 'R17', 'R18', 'R19', 'R20', 'R21', 'R22', 'R23', 'R24', 'R34', 'DFCT_023'];
    const REASON_CODES_POS = ['0001', '0002', '0003', '0004', '0005', '0006', '0007', '0008', '0014', '0015', '0016', '0017', '0018', '0019', '0020', '0021', '0022', '0023'];
    const reasonCode = returnedItems.some((item) => {
        const code = item?.Return?.Reason?.Code;
        return REASON_CODES_NPOS.includes(code) || REASON_CODES_POS.includes(code);
    });

    return (
      <>
        {reasonCode && (
        <>
          <p>**********{RL_DEFECTIVE}**********</p>
          <br />
        </>
            )}
      </>
    );
};

DefectiveHeader.defaultProps = {
    returnedItems: [],
};

DefectiveHeader.propTypes = {
    returnedItems: PropTypes.arrayOf(PropTypes.shape({})),
};

export default DefectiveHeader;
